import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { LicitacionService } from 'src/app/service/licitacion.service';

@Component({
  selector: 'app-actualizacion-contrasena',
  templateUrl: './actualizacion-contrasena.component.html',
  styleUrls: ['./actualizacion-contrasena.component.css']
})
export class ActualizacionContrasenaComponent implements OnInit {

  RouteText : any;
  tituloseo: any;
  urlcanonicaseo: any;
  imagenseo: any;
  keywordsseo: any;
  descripcionseo: any;
  fieldTextType: boolean = false;
  fieldTextType2: boolean = false;
  ////////
  confirma = false;
  success= false;
  fail = false;
  formsend: any;
  ///////

  constructor( 
    private meta: Meta,
    private title: Title,
    private _seoService: SeoService,
    private router: Router,
    private _licitacionservice: LicitacionService,
    private _urlcanonicaservice: UrlcanonicaService
    ) { 
      if((sessionStorage.getItem('token') == null || sessionStorage.getItem('token') == 'null')||(sessionStorage.getItem('rfc') == null || sessionStorage.getItem('rfc') == 'null')){
        this.router.navigate(['/licitaciones/login']);
      }
      this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.RouteText = event;
        this.getSEO(event.url)
      });
    }

    toggleFieldTextType() {
      this.fieldTextType = !this.fieldTextType;
    }

    toggleFieldTextType2() {
      this.fieldTextType2 = !this.fieldTextType2;
    }

  getSEO(page: string){
    this._seoService.getSEO(page).subscribe((resp: any) => {
      this.tituloseo = resp.titulo;
      this.descripcionseo = resp.descripcion;
      this.urlcanonicaseo =  resp.urlcanonica;
      this.imagenseo = resp.imagen; 
      this._urlcanonicaservice.createCanonicalLink();
      this.title.setTitle(this.tituloseo)
      this.meta.updateTag({
        name: 'description',
        content:
          this.descripcionseo
      })

      			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/recuperar-contrasena'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
    });
  }

  ngOnInit(): void {
  }

  //////////
  onSubmit(form: NgForm) {
    this.formsend = form
    if (form.value.password === form.value.confirmaNuevaContrasena) {
      const formulario = {
        Password: form.value.password,
        rfc:sessionStorage.getItem('rfc')
      };
      this._licitacionservice.postResetPass(formulario).subscribe(resp => {
          
          this.formsend.reset();
          this.success = true;
          this.confirma = false;
        },
        e => {
          console.log(e)
          //this.isLoading = false;
        }
      );
      this.success= true;
    }else {
      this.fail = true;
    }
  }
  closeok() {
    this.success= false;
    this.router.navigate(['/licitaciones/login']);
  }
  cancel() {
    this.fail = false;
  }
  ////////////

}

